export default __webpack_public_path__ + "static/media/NetatmoOn.f34669f4.svg";